import { PaletteOptions, ThemeOptions } from '@mui/material';

export function themeComponents(palette: PaletteOptions | undefined): ThemeOptions['components'] {
    return {
        /*MuiButton: {
                styleOverrides: {
                    root: {
                        color: '#000000de',
                        ":hover": {
                            backgroundColor: '#F5F5F5'
                        }
                    }
                }
            },*/
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    marginBottom: '1rem',
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    textTransform: 'capitalize',
                },
            },
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    justifyContent: 'flex-end',
                    gap: '1rem',
                    padding: '1rem',
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: palette?.backgroundMainLayout?.main,
                    },
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: '36px',
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    '&:-webkit-autofill': {
                        transitionDelay: '9999s',
                        transitionProperty: 'background-color, color',
                    },
                },
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
        },
        MuiStack: {
            defaultProps: {
                useFlexGap: true,
            },
        },
        MuiAutocomplete: {
            defaultProps: {
                componentsProps: {
                    paper: {
                        elevation: 4,
                    },
                },
            },
        },
        MuiUseMediaQuery: {
            defaultProps: {
                //setting this is INCREDIBLY important as we dont use SSR and it mistakenly returns incorrect values on first pass
                //https://stackoverflow.com/questions/68497916/material-ui-usemediaquery-not-initially-recognising-correct-breakpoint
                noSsr: true,
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    '&+.MuiDialogContent-root': {
                        paddingTop: '20px !important',
                    },
                    backgroundColor: palette?.appHeader?.main,
                    color: palette?.appHeader?.contrastText,
                },
            },
        },
    };
}
